import React from "react";
import { useTranslation } from "react-i18next";

import "./DashboardHeader.scss";
import UserAvatar from "../../../UserAvatar/UserAvatar";
import useAuth from "../../../../hooks/useAuth";
import StreakCount from "../../StreakCount/StreakCount";
import useStreakStatusQuery from "../../../../react-query/queries/use-streak-status";

function DashboardHeader() {
  const { userProfile } = useAuth();
  const { t } = useTranslation("dashboard");
  const { data: streakStatus } = useStreakStatusQuery();

  return (
    <header className="dashboard-header">
      <div className="greeting-container">
        <UserAvatar />
        <h1 className="greeting text-capitalize">
          {t("hi")} {userProfile?.username}
        </h1>
      </div>
      {streakStatus?.streakCount != null && (
        <StreakCount streakStatus={streakStatus} />
      )}
    </header>
  );
}

export default DashboardHeader;
